(function ($) {
  powerCouplesFormatterV1 = {
    formatter: $('.power-couples-formatter-v1')
  };

  Drupal.behaviors.powerCouplesFormatterV1 = {
    get: function (key) {
      return powerCouplesFormatterV1[key];
    },

    set: function (key, val) {
      powerCouplesFormatterV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        // sticky header - **MPC 3.12.14 - commented out to use the global sticky nav
        $('.power_couple_sticky_content').appendTo($('#sticky_bar_content')).attr('style', '');
        /* 
      var formatterPos = thisFormatter.offset();
      var $stickyHeader = thisFormatter.find('.power-couples-sticky-header');
      var $window = $(window);
      var $header = $('#top');
      var headerPos = $header.css('top');
      var mainOffset = $('#main').offset();
      
      $stickyHeader.css('top', headerPos).prependTo('.wrapper');
      
      $window.scroll(function() {
        if ($window.scrollTop() > formatterPos.top - mainOffset.top) {
          $header.slideUp(50, function() {
            $stickyHeader.slideDown(200).addClass('active');
          }).addClass('power-couples-hidden');
        }
        
        if ($window.scrollTop() < formatterPos.top - mainOffset.top) {
          $stickyHeader.hide().removeClass('active');
          $header.show().removeClass('power-couples-hidden');
        }  
      });
      */
        // anchor links in header

        var container = $('.supercat-header-v1 .header-details');

        container.append('<div class="power-couples-row-anchors"></div>');
        var $rows = thisFormatter.find('.power-couples-row-v1');

        if (container.length == 1 && $rows.length > 0) {
          var newContainer = $('.power-couples-row-anchors');

          // Check if anchors already exists so duplication doesn't happen on attachBehaviors.
          if (newContainer[0] && newContainer.length > 1) {
            return null;
          }

          $rows.each(function () {
            var rowID = $(this).attr('id');
            var rowTitle = $(this).find('h3').text();

            // console.log(rowID, rowTitle);
            newContainer.append('<a class="cl-icon ' + rowID + '" href="#' + rowID + '">' + rowTitle + '</a>');
          });

          newContainer.find('.cl-icon').hover(function () {
            $(this).toggleClass('active');
          }, function () {
            $(this).toggleClass('active');
          });
        }
      });

      if (Drupal.cl.hasPersonalization()) {
        if (site.profile && site.profile.products) {
          site.profile.products.powerCouples.init();
        }
      }
    }
  };
})(jQuery);
